import createReactComponent from '../createReactComponent';
export default createReactComponent('mail-check', 'IconMailCheck', [
  [
    'path',
    {
      d: 'M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M3 7l9 6l9 -6', key: 'svg-1' }],
  ['path', { d: 'M15 19l2 2l4 -4', key: 'svg-2' }],
]);
